import { Component, OnInit } from '@angular/core';
import { CompromisosXFecha } from '../../shared/entities/CompromisosXFecha';
import { VisualizadorService } from '../../shared/service/visualizador.service';
import { UtilidadCalendario } from '../../shared/utilities/utilidad-calendario';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Compromiso } from '../../shared/entities/Compromiso';
import { Router } from '@angular/router';
import { UtilidadGeneraTabla } from '../../shared/utilities/utilidad-genera-tabla';
import { Constantes } from '../../shared/constant/constantes';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-calendario-banrep',
  templateUrl: './calendario-banrep.component.html',
  styleUrls: ['./calendario-banrep.component.css']
})
export class CalendarioBanrepComponent implements OnInit {

  public utilCal: UtilidadCalendario = new UtilidadCalendario();
  public utilidadTabla: UtilidadGeneraTabla = new UtilidadGeneraTabla();
  public constantes: Constantes = new Constantes();

  public tipoTabla: string = 'SEMANA';
  public categorias!: Map<number, string>;
  public tipoPublicacionSelected: string = 'SI';

  public mapaCompromisos: Map<number, Array<any>> = new Map();
  public listaCompletaCompromisos: Array<Compromiso> = new Array();
  public listaCompromisoActual: Array<Compromiso> = new Array();
  public listaCompromisoConsulta: Array<Compromiso> = new Array();

  public listaComSemanaVista: Array<CompromisosXFecha> = new Array();
  public listaComMesVista: Array<CompromisosXFecha> = new Array();

  public listaSemana: Array<string> = new Array();
  public listaFestivos: Array<string> = new Array();

  public fechaDiaUno!: Date;
  public fechaDiaDos!: Date;
  public fechaDiaTres!: Date;
  public fechaDiaCuatro!: Date;
  public fechaDiaCinco!: Date;
  public fechaMes!: Date;
  public tituloFecha!: string;

  public fechaCalendario: Date | null = null;

  public tipoDispositivo!: string;

  public palabraBusqueda: string = '';

  public accionBoton: string = '';
  public tituloFechaCorte: string = '';

  public cargandoInfo:boolean = false;

  constructor(private service: VisualizadorService, public breakpointObserver: BreakpointObserver, private router: Router, private title: Title, private meta: Meta) { }

  ngAfterViewInit(): void {
    this.botonSeleccionado();
    this.service.setWindowScroll(0, 0);
  }

  ngOnInit(): void {
    this.title.setTitle('Calendario');
    this.meta.updateTag({ name: 'description', content: 'Calendario de publicación de datos.' });

    this.cargandoInfo = true;
    if (navigator.userAgent.includes('Mobile')) {
      this.tipoDispositivo = 'CELULAR';
      this.tipoTabla = 'LISTA';
    } else {
      this.breakpointObserver
        .observe([Breakpoints.Small, Breakpoints.XSmall])
        .subscribe(state => {
          if (state.matches) {
            this.tipoDispositivo = 'CELULAR';
            this.tipoTabla = 'LISTA';
          } else {
            this.tipoDispositivo = 'ESCRITORIO';
            this.tipoTabla = 'SEMANA';
          }
        });
    }
    this.accionBoton = '';
    var fechaHoy = new Date();
    this.generaCalendario(fechaHoy);
    this.generaCompromisos(fechaHoy);
    this.consultarCompromisoRestoAnnio(fechaHoy);
    this.cargandoInfo = false;
  }

  private generaCalendario(fechaHoy: Date) {
    var diaHoy = fechaHoy.getDay();
    var restarDia = diaHoy - 1;
    this.fechaMes = new Date(fechaHoy);
    var fechaInicial = this.utilCal.restarDias(fechaHoy, restarDia);
    this.generaDiasSemana(fechaInicial);
    this.generaTipoTablaMostrar(this.tipoTabla);
  }

  private generaCompromisos(fechaHoy: Date) {
    this.consultarlistaCompromiso(fechaHoy);
    if (this.fechaDiaUno.getMonth() < this.fechaDiaCinco.getMonth() ||
      this.fechaDiaUno.getFullYear() < this.fechaDiaCinco.getFullYear()) {
      this.consultarlistaCompromiso(this.fechaDiaCinco);
      this.consultarlistaCompromiso(this.fechaDiaUno);
    }
  }

  private async consultarlistaCompromiso(fechaConsulta:Date) {
    const response = await this.consultarCompromisosService(fechaConsulta);
    this.crearMapaCompromisos(response);
    this.generaListaCompromisoXPublicacion();
  }

  private filtrarListaCompromisos(lista: Array<Compromiso>): Array<Compromiso> {
    var resultado: Array<Compromiso> = new Array();
    var mapa: Map<string, Compromiso> = new Map();
    lista.forEach(element => {
      var keyMapa: string = element.annio + element.mes + element.dia + '-' + element.descripcion;
      mapa.set(keyMapa, element);
    });

    const values = Array.from(mapa.values());
    values.forEach(v => {
      resultado.push(v);
    });

    return resultado;
  }

  private crearMapaCompromisos(lista: Array<Compromiso>) {
    var mapa: Map<string, Compromiso> = new Map();
    this.mapaCompromisos = new Map();
    if (this.listaCompletaCompromisos == undefined) {
      this.listaCompletaCompromisos = new Array();
    }
    this.listaCompletaCompromisos = this.listaCompletaCompromisos.concat(lista);
    this.listaCompletaCompromisos.forEach(element => {
      var keyMapa: string = element.annio + element.mes + element.dia + '-' + element.descripcion;
      //element.tituloFechaCorte = this.generaTituloFechaCorte(element);
      mapa.set(keyMapa, element);
    });
    this.listaCompletaCompromisos = new Array();
    const values = Array.from(mapa.values());
    values.forEach(v => {
      this.listaCompletaCompromisos.push(v);
    });
    this.mapaCompromisos.set(0, this.listaCompletaCompromisos);
  }

  public generaTipoTablaMostrar(tipo: string) {
    this.tipoTabla = tipo;
    this.botonSeleccionado();
    if (tipo == 'SEMANA') {
      this.tituloFecha = this.utilCal.generaEncabezadoSemana(this.fechaDiaUno, this.fechaDiaCinco);
    } else {
      this.tituloFecha = this.utilCal.generaEncabezadoMes(this.fechaMes);
      this.anclarPublicacionesHoy();
    }
  }

  public selectPublicaciones(event: any) {
    this.tipoPublicacionSelected = event.target.value;
    if (this.palabraBusqueda != '') {
      this.seleccionFechaHoy();
    }
    this.generaListaCompromisoXPublicacion();
    this.accionBoton = 'CATEGORIA';

  }

  private generaListaCompromisoXPublicacion() {
    let lista: Array<any> = new Array();
    lista = lista.concat(this.mapaCompromisos.get(0));
    this.listaCompletaCompromisos = new Array();
    if (this.tipoPublicacionSelected == 'SI') {
      lista.forEach(comp => {
        if (comp.datoProducidoBanrep == 'SI') {
          this.listaCompletaCompromisos.push(comp);
        }
      });
    } else {
      this.listaCompletaCompromisos = this.listaCompletaCompromisos.concat(lista);
    }
    this.buscarPalabraPublicacion();
  }

  public seguienteFecha() {
    if (this.tipoTabla == 'SEMANA') {
      var fechaInicial = this.utilCal.sumarDias(this.fechaDiaUno, 7);
      this.fechaMes = fechaInicial;
      this.generaDiasSemana(fechaInicial);
      this.tituloFecha = this.utilCal.generaEncabezadoSemana(this.fechaDiaUno, this.fechaDiaCinco);
      if (fechaInicial.getMonth() < this.fechaDiaCinco.getMonth() ||
        fechaInicial.getFullYear() < this.fechaDiaCinco.getFullYear() ||
        this.fechaDiaUno.getDate() <= 7 || this.fechaDiaUno.getDate() >= 25) {
          this.consultarlistaCompromiso(this.fechaDiaCinco);
      }
    } else {
      this.fechaMes = this.utilCal.sumarMeses(this.fechaMes, 1);      
      var primerDia = this.obtenerPrimerDiaHabil(this.fechaMes);
      var diaHoy = primerDia.getDay();
      var restarDia = diaHoy - 1;
      var fechaInicial = this.utilCal.restarDias(primerDia, restarDia);
      this.generaDiasSemana(fechaInicial);
      this.tituloFecha = this.utilCal.generaEncabezadoMes(this.fechaMes);
      this.consultarlistaCompromiso(this.fechaMes);
    }
    this.accionBoton = 'SIGUIENTE';
    this.buscarPalabraPublicacion();
  }

  public anteriorFecha() {
    if (this.tipoTabla == 'SEMANA') {
      var fechaInicial = this.utilCal.restarDias(this.fechaDiaUno, 7);
      this.fechaMes = fechaInicial;
      if (fechaInicial.getFullYear() < this.fechaDiaUno.getFullYear() || fechaInicial.getMonth() < this.fechaDiaUno.getMonth()) {
        this.consultarlistaCompromiso(fechaInicial);
      }
      this.generaDiasSemana(fechaInicial);
      this.tituloFecha = this.utilCal.generaEncabezadoSemana(this.fechaDiaUno, this.fechaDiaCinco);
    } else {
      this.fechaMes = this.utilCal.restarMeses(this.fechaMes, 1);
      var primerDia = this.obtenerPrimerDiaHabil(this.fechaMes);
      var diaHoy = primerDia.getDay();
      var restarDia = diaHoy - 1;
      var fechaInicial = this.utilCal.restarDias(primerDia, restarDia);
      this.generaDiasSemana(fechaInicial);

      this.tituloFecha = this.utilCal.generaEncabezadoMes(this.fechaMes);
      this.consultarlistaCompromiso(this.fechaMes);
    }
    this.accionBoton = 'ANTERIOR';
    this.buscarPalabraPublicacion();
  }

  public seleccionFechaHoy() {
    var fechaHoy = new Date();
    this.consultarlistaCompromiso(fechaHoy);
    var diaHoy = fechaHoy.getDay();
    var restarDia = diaHoy - 1;
    var fechaInicial = this.utilCal.restarDias(fechaHoy, restarDia);
    this.generaDiasSemana(fechaInicial);
    this.fechaMes = new Date(fechaHoy);
    if (this.tipoTabla == 'SEMANA') {
      this.tituloFecha = this.utilCal.generaEncabezadoSemana(this.fechaDiaUno, this.fechaDiaCinco);
    } else {
      this.tituloFecha = this.utilCal.generaEncabezadoMes(this.fechaMes);
      this.anclarPublicacionesHoy();
    }
    this.resetComponentesCalendario();
  }

  private generaDiasSemana(paramFecha: Date) {
    this.fechaDiaUno = paramFecha;
    this.fechaDiaDos = this.utilCal.sumarDias(paramFecha, 1);
    this.fechaDiaTres = this.utilCal.sumarDias(paramFecha, 2);
    this.fechaDiaCuatro = this.utilCal.sumarDias(paramFecha, 3);
    this.fechaDiaCinco = this.utilCal.sumarDias(paramFecha, 4);
  }

  public selectFechaCalendario(event: MatDatepickerInputEvent<Date>) {
    this.cargandoInfo = true;
    this.fechaCalendario = event.value!;
    this.consultarlistaCompromiso(this.fechaCalendario);
    this.accionBoton = 'CALENDARIO';
    var diaHoy = this.fechaCalendario.getDay();
    var restarDia = diaHoy - 1;
    var fechaInicial = this.utilCal.restarDias(this.fechaCalendario, restarDia);
    this.generaDiasSemana(fechaInicial);
    this.fechaMes = new Date(this.fechaCalendario);
    if (this.tipoTabla == 'SEMANA') {
      this.tituloFecha = this.utilCal.generaEncabezadoSemana(this.fechaDiaUno, this.fechaDiaCinco);
    } else {
      this.tituloFecha = this.utilCal.generaEncabezadoMes(this.fechaMes);
    }
    this.cargandoInfo = false;
  }

  public botonSeleccionado() {
    if (document.getElementById('boton-semana') != null) {
      var botonSemana = document.getElementById('boton-semana');
      var botonLista = document.getElementById('boton-lista');
      if (this.tipoTabla == 'SEMANA') {
        botonSemana!.classList.add('boton-calendar-rojo-selected');
        botonLista!.classList.remove('boton-calendar-rojo-selected');
      } else {
        botonLista!.classList.add('boton-calendar-rojo-selected');
        botonSemana!.classList.remove('boton-calendar-rojo-selected');
      }
    }
  }

  private anclarPublicacionesHoy() {
    setTimeout(function () {
      var fechaHoy = new Date();
      var id = fechaHoy.getDate() + '' + fechaHoy.getMonth() + '' + fechaHoy.getFullYear();
      if (document.querySelector("#encabezado-" + id) != null) {
        document.querySelector("#encabezado-" + id)!.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 500);
  }

  private resetComponentesCalendario() {
    this.fechaCalendario = null;
    this.palabraBusqueda = '';
    this.tituloFechaCorte = '';
    this.tipoPublicacionSelected = 'SI';
    this.accionBoton = '';
  }

  /**
   * CONSULTA POR PALABRA CLAVE
   */
  public async buscarXPalabraClave() {
    this.accionBoton = '';
    this.cargandoInfo = true;
    var fechaHoy = new Date();
    var listaFechas = this.generaListaMeses(fechaHoy, 12);
    this.listaCompromisoActual = new Array();
    this.listaCompromisoConsulta = new Array();
    for (const fechaConsulta of listaFechas) {
      if (this.listaCompromisoConsulta.length <= 0) {
        this.generaCalendario(fechaConsulta);
        this.listaCompromisoConsulta = new Array();
        const response = await this.consultarCompromisosService(fechaConsulta);
        this.buscarPalabraPublicacion();
      }
    }
    this.cargandoInfo = false;
  }

  public buscarPalabraPublicacion() {
    var value = this.palabraBusqueda;
    if(value != null && ('inflación' === value || 'inflacion' === value)){
      value = 'ipc';
    }
    this.tituloFechaCorte = '';
    this.listaCompromisoConsulta = new Array();
    
    //Variable para quitar el timestamp
    var fechaDiaUnoTmp = new Date(this.fechaDiaUno.getFullYear(), this.fechaDiaUno.getMonth(), this.fechaDiaUno.getDate());
    
    if (this.isFechaProximaPublicacion()) {
      if (value != '') {
        this.tipoPublicacionSelected = 'TODOS';
        var palabraABuscarMinus = this.utilidadTabla.validaPalabra(value);
        this.listaCompromisoActual.forEach(publicacion => {
          var nombrePublicacionMinus = this.utilidadTabla.validaPalabra(publicacion.descripcion);
          if (this.utilidadTabla.isPalabraCoincide(palabraABuscarMinus, nombrePublicacionMinus)) {
            let fechaCompromiso: Date = new Date(publicacion.fechaCompleta);
            if (this.accionBoton == 'ANTERIOR') {
              if (fechaCompromiso >= fechaDiaUnoTmp && fechaCompromiso <= this.fechaDiaCinco) {
                this.listaCompromisoConsulta.push(publicacion);
              }
            } else {
              if (fechaCompromiso >= fechaDiaUnoTmp) {
                this.listaCompromisoConsulta.push(publicacion);
              }
            }
          }
        });
        if (this.listaCompromisoConsulta.length > 0) {
          this.listaCompromisoConsulta.sort(function (a, b) {
            const horaA = new Date(a.fechaCompleta);
            const horaB = new Date(b.fechaCompleta);
            if (horaA < horaB) {
              return -1
            }
            if (horaA > horaB) {
              return 1
            }
            return 0;
          });
          var fechaUno = new Date(this.listaCompromisoConsulta[0].fechaCompleta);
          this.generaCalendario(fechaUno);
        }
      } else {
        this.listaCompromisoConsulta = this.listaCompletaCompromisos;
      }
    } else {
      this.listaCompromisoConsulta = this.listaCompletaCompromisos;
    }
    this.listaComSemanaVista = new Array();
    this.listaComMesVista = new Array(); 
    if (this.listaCompletaCompromisos != undefined) {
      if (this.listaFestivos.length > 0 && this.fechaMes.getFullYear() > this.fechaDiaCinco.getFullYear()) {
        this.listaComSemanaVista = this.utilCal.generaListaSemana(this.listaCompromisoConsulta, this.fechaDiaUno, this.listaFestivos);
        this.listaComMesVista = this.utilCal.generaListaMes(this.listaCompromisoConsulta, this.fechaMes, this.listaFestivos);
      } else {
        this.service.getFestivosAnnio(this.fechaDiaCinco.getFullYear()).subscribe({
          next: (response) => {
            this.listaFestivos = response;
            this.listaComSemanaVista = this.utilCal.generaListaSemana(this.listaCompromisoConsulta, this.fechaDiaUno, this.listaFestivos);
            this.listaComMesVista = this.utilCal.generaListaMes(this.listaCompromisoConsulta, this.fechaMes, this.listaFestivos);
          },
          error: (error) => {
            console.log("Error inesperado en getFestivosAnnio", error);
          }
        });
      }
    }
  }

  private isFechaProximaPublicacion() {
    var fechaHoy = new Date();
    var anioActual = fechaHoy.getFullYear();
    var mesActual = fechaHoy.getMonth() + 1;
    var anioSiguiente = fechaHoy.getFullYear() + 1;
    var anioCalendario = this.fechaMes.getMonth();
    var mesCalendario = this.fechaMes.getMonth() + 1;
    if (anioCalendario == anioActual && mesCalendario >= mesActual) {
      return true;
    } else if (anioSiguiente > anioCalendario) {
      return true;
    } else {
      return false;
    }
  }

  private consultarCompromisoRestoAnnio(fechaConsulta: Date) {
    this.listaCompromisoActual = new Array();
    var currentYear = fechaConsulta.getFullYear();
    var currentMonth = fechaConsulta.getMonth() + 1;
    this.service.getCompromisosXCategoriaXAnnio(currentYear, currentMonth).subscribe({
      next: (response) => {
        if (response != null && response.length > 0) {
          let listaFiltrada = this.filtrarListaCompromisos(response);
          listaFiltrada.forEach(publicacion => {
            this.listaCompromisoActual.push(publicacion);
          });
        } else {
          let publicacion = new Compromiso();
          this.listaCompromisoActual.push(publicacion);
        }
      },
      error: (error) => {
        console.log("Error inesperado en getCompromisosXCategoriaXAnnio", error);
      }
    });
  }

  private generaListaMeses(fechaIni: Date, cantidad: number): Array<Date> {
    let listaFechas: Array<Date> = new Array();
    let fechaResultado: Date = fechaIni;
    for (let i = 0; i <= cantidad; i++) {
      listaFechas.push(new Date(fechaResultado));
      fechaResultado.setMonth(fechaResultado.getMonth() + 1);
      fechaResultado.setDate(1);
    }
    return listaFechas;
  }

  async consultarCompromisosService(fechaConsulta: Date): Promise<Array<Compromiso>> {
    this.listaCompromisoActual = new Array();
    const response = await new Promise<Array<Compromiso>>((resolve, reject) => {
      this.service.getCompromisosXCategoriaXAnnio(fechaConsulta.getFullYear(), fechaConsulta.getMonth() + 1).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (error) => {
          console.log("Error inesperado en getCompromisosXCategoriaXAnnio", error);
          reject(error);
        }
      });
    });
    if (response != null && response.length > 0) {
      let listaFiltrada = this.filtrarListaCompromisos(response);
      listaFiltrada.forEach(publicacion => {
        this.listaCompromisoActual.push(publicacion);
      });
    } else {
      let publicacion = new Compromiso();
      this.listaCompromisoActual.push(publicacion);
    }
    return response;
  }

  private obtenerPrimerDiaHabil(fecha:Date):Date {
    // Crear una copia de la fecha original
    let fechaActual = new Date(fecha);

    fechaActual.setDate(1);
  
    // Verificar si el día actual es hábil (de lunes a viernes)
    while (fechaActual.getDay() === 0 || fechaActual.getDay() === 6) {
      // Avanzar al siguiente día
      fechaActual.setDate(fechaActual.getDate() + 1);
    }
  
    return fechaActual;
  }  

}
